import { computed, ref } from 'vue';
import { useEventListener } from '@vueuse/core';
import { store } from '@/plugins/store';

function isEditable(target: EventTarget | null) {
    const element = target as HTMLElement | null;

    return !!element && (['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName) || element.isContentEditable);
}

/**
 * Open state of the System Configuration page, toggled by Ctrl+Alt+Shift+A.
 * The shortcut does nothing unless the signed-in user's token carries the system-administrator claim,
 * and it never opens while the user is typing in a field.
 */
export function useSystemConfigurationShortcut() {
    const isOpen = ref(false);

    function close() {
        isOpen.value = false;
    }

    function onKeydown(event: KeyboardEvent) {
        if (!(event.ctrlKey && event.altKey && event.shiftKey && event.code === 'KeyA')) {
            return;
        }

        if (isOpen.value) {
            close();
        } else if (!isEditable(event.target)) {
            isOpen.value = true;
        }
    }

    // Attached only for system administrators; everyone else pays no per-keystroke cost.
    useEventListener(
        computed(() => (store.state.userIsSa ? window : null)),
        'keydown',
        onKeydown
    );

    return { isOpen, close };
}
